var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('select2',{attrs:{"id":_vm.id,"name":_vm.name,"value":_vm.value,"multiple":false,"preloadDataConfig":{
            method: 'get',
            payload: {
                include_relations: false,
            },
            resultsObjectPath: 'body.body.modules',
            valuesOfInterest: {
                id: 'id',
                text: 'name',
            },
            url: '/api/modules',
        },"canCreateSearchChoice":_vm.canCreateSearchChoice,"disabled":_vm.disabled,"flattenToOptgroups":_vm.flattenToOptgroups,"isActiveEntryFilter":_vm.isActiveEntryFilter,"lazyLoading":_vm.lazyLoading,"required":_vm.required,"optionsData":_vm.optionsData,"placeholder":_vm.placeholder,"preselectFirst":_vm.preselectFirst,"refreshFields":_vm.refreshFields,"relatedTableName":_vm.relatedTableName,"focus":_vm.focus},on:{"change":_vm.onChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }